import React, { useMemo } from 'react';
import { Button } from "devextreme-react";
import PropTypes from 'prop-types';
import './PeriodButton.css';

const PeriodButton = React.memo(({ 
  period, 
  label, 
  selected, 
  visible, 
  onClick, 
  name 
}) => (
  <Button
    className={`period-button ${selected ? 'selected' : ''}`}
    name={name}
    onClick={() => onClick(period)}
    visible={visible} // Change from style.display to visible prop
    aria-pressed={selected}
    aria-label={`Select ${label} period`}
    text={label}
    type="normal"
    stylingMode="contained"
  >
    {label}
  </Button>
));

PeriodButton.propTypes = {
  period: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  visible: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired
};

export const PeriodButtons = ({ 
  selectedPeriod, 
  onPeriodChange, 
  checkAuthorization,
  getYearLabel 
}) => {
  const periods = useMemo(() => [
    { period: 1, label: 'L3M', name: 'L3M', auth: null },
    { period: 2, label: 'L12M', name: 'L12M', auth: null },
    { period: 3, label: getYearLabel(0), name: 'y0', auth: 'Y0' },
    { period: 4, label: getYearLabel(1), name: 'y1', auth: 'Y1' },
    { period: 5, label: getYearLabel(2), name: 'y2', auth: 'Y2' },
    { period: 6, label: getYearLabel(3), name: 'y3', auth: 'Y3' },
    { period: 7, label: 'YOY', name: 'yt', auth: 'Y0' }
  ], [getYearLabel]);

  return (
    <div className="period-buttons" role="toolbar" aria-label="Period selection">
      {periods.map(({ period, label, name, auth }) => (
        <PeriodButton
          key={period}
          period={period}
          label={label}
          name={name}
          selected={selectedPeriod === period}
          visible={auth ? checkAuthorization(auth) !== 'none' : true}
          onClick={onPeriodChange}
        />
      ))}
    </div>
  );
};

PeriodButtons.propTypes = {
  selectedPeriod: PropTypes.number.isRequired,
  onPeriodChange: PropTypes.func.isRequired,
  checkAuthorization: PropTypes.func.isRequired,
  getYearLabel: PropTypes.func.isRequired
};

export default PeriodButtons;